import { JSX, PropsWithChildren } from "react";

export const EstablishmentManagerQualificationDetailWrapper = (
    props: PropsWithChildren,
): JSX.Element => {
    return <div className={"p-qualification-detail"}>{props.children}</div>;
};
